import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "row mb-2" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col fw-bold" }, "Wählen Sie aus der folgenden Tabelle einen Eintrag aus, um ihn zu bearbeiten.")
], -1);
const _hoisted_2 = { class: "col-6 col-md-8 mt-3 mb-3" };
const _hoisted_3 = { class: "col-3 col-md-2 mt-3 mb-3" };
const _hoisted_4 = { class: "col-3 col-md-2 mt-3 mb-3" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-6 col-md-3" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-6 d-md-block d-none" }, null, -1);
const _hoisted_8 = { class: "col-6 col-md-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _hoisted_1,
        _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.pages, (tPage) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row border border-2 bg-light ms-0 me-0 mb-2 align-items-center",
                    key: tPage.id
                }, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(tPage.title), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_g_button, {
                            text: "Bearbeiten",
                            onClick: ($event) => (_ctx.onCommand('page-goto', { page: tPage })),
                            disabled: !tPage.isEnabled
                        }, null, 8, ["onClick", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_g_button, {
                            text: "Entfernen",
                            onClick: ($event) => (_ctx.onCommand('page-remove', { master: _ctx.page, page: tPage })),
                            disabled: _ctx.page.pages.length <= 1 || !tPage.isEnabled
                        }, null, 8, ["onClick", "disabled"])
                    ])
                ]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                (_ctx.canAddMore)
                    ? (_openBlock(), _createBlock(_component_g_button, {
                        key: 0,
                        text: "+ Hinzufügen",
                        "button-style": "btn-outline-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCommand('page-add', { page: _ctx.page }))),
                        isLoading: _ctx._isWorking
                    }, null, 8, ["isLoading"]))
                    : _createCommentVNode("", true)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_g_button, {
                    text: _ctx.page.nextText,
                    disabled: !_ctx.page.nextCommand2,
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onCommand(_ctx.page?.nextCommand2, { page: _ctx.page }))),
                    isLoading: _ctx._isWorking
                }, null, 8, ["text", "disabled", "isLoading"])
            ])
        ])
    ], 64));
}
